import type { LayerChange } from "./types";

export type LayerEvents = {
  stop(): Promise<void>;
};

export const layerChangedEvent = "layerChanged";

export const layerEventsRetryDelayMs = 5000;

const idleLayerEvents: LayerEvents = { stop: () => Promise.resolve() };

export async function openLayerEvents(url: string, token: () => string | null, handler: (change: LayerChange) => void, retryDelayMs = layerEventsRetryDelayMs): Promise<LayerEvents> {
  if (!token()) return idleLayerEvents;

  const { HubConnectionBuilder } = await import("@microsoft/signalr");
  const connection = new HubConnectionBuilder()
    .withUrl(url, { accessTokenFactory: () => token() ?? "" })
    .withAutomaticReconnect()
    .build();
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const schedule = () => {
    if (stopped || timer !== null || !token()) return;

    timer = setTimeout(() => {
      timer = null;
      void start();
    }, retryDelayMs);
  };

  const start = async (): Promise<void> => {
    if (stopped) return;

    try {
      await connection.start();
    } catch {
      schedule();
    }
  };

  connection.on(layerChangedEvent, handler);
  connection.onclose(() => schedule());
  void start();

  return {
    stop: async () => {
      stopped = true;

      if (timer !== null) clearTimeout(timer);

      timer = null;
      await connection.stop();
    }
  };
}
